<script lang="ts" setup></script>

<template>
	<NuxtLayout>
		<NuxtLoadingIndicator color="#F37323" />
		<NuxtPage> </NuxtPage>
		<UNotifications />
	</NuxtLayout>
</template>
